import { BAYS } from '../../../../constants';

export enum TreatmentPlanPages {
  ClientInfo = 'Info',
  MedInfo = 'Medical',
  Medications = 'Meds',
  History = 'History',
  Background = 'Background',
  Assessment = 'Assessment',
  CrisisPlan = 'Crisis Plan',
  Goals = 'Goals',
  DischargeTransition = 'Discharge',
  TreatmentRecommendation = 'Treatment',
}

export const TPBayDescription = {
  [BAYS.BAY_2_5]: '',
  [BAYS.BAY_2_6]:
    'This protocol will be administered by a behavioral technician, who has gone through the necessary training and additional certifications, as applicable. The behavioral technician will be supervised by the BCBA overseeing this treatment plan.',
  [BAYS.BAY_3]: '',
  [BAYS.BAY_6]:
    'This protocol will be administered by a certified Board Certified Behavior Analyst (BCBA).',
};

export enum TreatmentPlanStatus {
  Completed = 'COMPLETED',
  Started = 'STARTED',
  Editing = 'EDITING',
  Readonly = 'READ_ONLY',
}

export const BehaviorDescriptionMap = {
  'behavior change':
    'To support the application of functionally equivalent replacement behaviors that serve the hypothesized function of the maladaptive behaviors',
  communication:
    'To support improved functional communication to convey wants or needs to communicative partners for {{desired items or activities/ requiring assistance/ break from demands/ attention}}.',
  'communication-tact':
    "To support an increase in the client's language repertiore that will improve overall functional communication across environments and communicative partners.",
  'executive functioning':
    'To support improved functional and adaptive skills used to navigate everyday tasks, including {{problem-solving, critical thinking, emotional regulation, decision-making, and working memory}}.',
  imitation:
    'To support improved fundamental skills necessary for understanding {{social norms, social cues, reciprocal interactions, cause-and-effect relationships, sequencing}}.',
  'listener responding':
    'To support effective responding to communicative partners when presented with {{instructions and conversational interactions}} that incorporate various vocabulary and concepts required for daily functional skills.',
  'parent training':
    'To equip parents and caregivers with the necessary knowledge and skills to implement evidence-based ABA strategies across familiar and novel environments to ensure positive, socially significant outcomes.',
  play: 'To support improved participation across all social situations through the incorporation of play activities that promote {{exploration, creativity, problem-solving, relationship-building, and communicative interactions}} across a variety of communicative partners.',
  social:
    'To support improved appropriate interactions with communicative partners that include understanding of {{initiating conversations, non-verbal cues (e.g. facial expressions), relationship-building, maintaining social-interactions}}.',
  pairing:
    'To increase outcomes for building trusting, positive relationships between the client and stakeholders (e.g. parents, caregivers, family member, therapists, medical providers, educators, etc.) throughout treatment that will support improved participation and the development of necessary functional skills.',
  'visual perception':
    'To support an improved understanding of visual information presented across environments that are vital for completing everyday tasks or activities that target specific skills including {{visual discrimination, visual memory, spatial relationships, figure-ground perception, visual closure}}.',
};

export enum TreatmentPlanResourceVersion {
  V1 = 'v1',
  V2 = 'v2',
}
